import moment from "moment";
import React from "react";
import { QR } from "../../types/interfaces";
import {
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTd,
  StyledTh,
  StyledTr,
} from "./styled";
import { MdModeEditOutline, MdDelete, MdDownload } from "react-icons/md";

interface Props {
  data: QR[];
  onEdit: (qr: QR) => void;
  onDelete: (qr: QR) => void;
  onDownload: (qr: QR) => void;
}

const QrTable: React.FC<Props> = ({ data, onEdit, onDelete, onDownload }) => {
  return (
    <StyledTable>
      <StyledTableHead>
        <StyledTr>
          <StyledTh>QR</StyledTh>
          <StyledTh>Name</StyledTh>
          <StyledTh>type</StyledTh>
          <StyledTh className="qr_id_th">QR ID</StyledTh>
          <StyledTh>Last updates</StyledTh>
          <StyledTh>Actions</StyledTh>
        </StyledTr>
      </StyledTableHead>
      <StyledTableBody>
        {data.map((row) => (
          <StyledTr key={row._id}>
            <StyledTd>
              <img id="qr-img-src" src={row.qr?.secure_url} alt="qr" />
            </StyledTd>
            <StyledTd>{row.qrName}</StyledTd>

            <StyledTd className="qr-type">{row.qrType}</StyledTd>
            <StyledTd className="qr_id_tr">{row._id}</StyledTd>
            <StyledTd>{moment(row.createdAt).format("Do MMM, YYYY")}</StyledTd>
            <StyledTd>
              <MdModeEditOutline onClick={() => onEdit(row)} />
              <MdDelete onClick={() => onDelete(row)} />
              <MdDownload onClick={() => onDownload(row)} />
            </StyledTd>
          </StyledTr>
        ))}
      </StyledTableBody>
    </StyledTable>
  );
};

export default QrTable;
